import React, { FC } from "react";

import { carpool } from "../../assets/images";

import { useNavigate } from "react-router-dom";

interface ActiveRentalProps {
  // activeRental: RentalType;
  rentalId: string;
}
const ActiveRental: FC<ActiveRentalProps> = ({ rentalId }) => {
  const navigate = useNavigate();

  // watchUserLocation().then((location) => {
  //   console.log(location);
  // });
  // useEffect(() => {
  //   if (activeRental.carId.parkedLocation) {
  //     let map: google.maps.Map;

  //     loader.importLibrary("maps").then((google) => {
  //       map = new google.Map(document.getElementById("mapDiv") as HTMLElement, {
  //         // center: { lat: 6.5244, lng: 3.3792 },
  //         center: {
  //           lat: activeRental.carId.parkedLocation.latitude,
  //           lng: activeRental.carId.parkedLocation.longitude,
  //         },
  //         zoom: 8,
  //         mapId: activeRental.id,
  //       });
  //     });

  //     loader.importLibrary("marker").then((google) => {
  //       const vehicleImg = document.createElement("img");
  //       vehicleImg.src = ipfsGatewayImage(image);
  //       vehicleImg.style.width = "80px";
  //       vehicleImg.style.height = "80px";
  //       vehicleImg.style.borderRadius = "50%";
  //       vehicleImg.style.objectFit = "cover";
  //       vehicleImg.style.objectPosition = "center";
  //       vehicleImg.style.cursor = "pointer";
  //       vehicleImg.style.animation = "blinking 2s infinite";
  //       vehicleImg.style.padding = "10px";
  //       vehicleImg.style.backgroundColor = "white";
  //       vehicleImg.style.boxShadow = "0px 0px 10px 0px rgba(0,0,0,0.75)";

  //       new google.AdvancedMarkerElement({
  //         position: {
  //           lat: activeRental.carId.parkedLocation.latitude,
  //           lng: activeRental.carId.parkedLocation.longitude,
  //         },
  //         map: map,
  //         title: "Vehicle Location",
  //         content: vehicleImg,
  //       });

  //       new google.AdvancedMarkerElement({
  //         position: {
  //           lat: activeRental.carId.parkedLocation.latitude + 0.0001,
  //           lng: activeRental.carId.parkedLocation.longitude + 0.0001,
  //         },
  //         map: map,
  //         title: "Your Location",

  //         // content: vehicleImg,
  //       });
  //     });

  //     loader.importLibrary("routes").then((google) => {
  //       const directionsService = new google.DirectionsService();
  //       const directionsRenderer = new google.DirectionsRenderer();
  //       directionsRenderer.setMap(map);

  //       directionsService.route(
  //         {
  //           origin: {
  //             lat: activeRental.carId.parkedLocation.latitude + 0.1,
  //             lng: activeRental.carId.parkedLocation.longitude + 0.1,
  //           },
  //           destination: {
  //             lat: activeRental.carId.parkedLocation.latitude,
  //             lng: activeRental.carId.parkedLocation.longitude,
  //           },
  //           travelMode: google.TravelMode.DRIVING,
  //         },
  //         (response, status) => {
  //           if (status === "OK") {
  //             // console.log(response);
  //             directionsRenderer.setDirections(response);
  //           } else {
  //             window.alert("Directions request failed due to " + status);
  //           }
  //         }
  //       );
  //     });
  //   }
  // });

  // useEffect(() => {
  //   if (!image) {
  //     setLoading(true);

  //     // }
  //     const imgArr = activeRental.carId?.carImages?.filter(
  //       (image) => image.imageUrl
  //     );
  //     const imgMap = imgArr.map((image) => image.imageUrl);
  //     const imgArrs = new Set(imgMap);

  //     setImage(Array.from(imgArrs)[0]);

  //     setLoading(false);
  //   }

  //   if (!vehicleLocation) {
  //     loader.importLibrary("geocoding").then((google) => {
  //       const geocoder = new google.Geocoder();
  //       geocoder.geocode(
  //         {
  //           location: {
  //             lat: activeRental.carId.parkedLocation.latitude,
  //             lng: activeRental.carId.parkedLocation.longitude,
  //           },
  //         },
  //         (results, status) => {
  //           if (status === "OK") {
  //             if (results?.length) {
  //               setVehicleLocation(results[0].formatted_address);
  //             } else {
  //               window.alert("No results found");
  //             }
  //           } else {
  //             window.alert("Geocoder failed due to: " + status);
  //           }
  //         }
  //       );
  //     });
  //   }
  // }, [activeRental.carId, image, vehicleLocation]);

  return (
    <div className="w-full flex flex-col lg:flex-row justify-between items-center bg-white p-4 ">
      <div className="flex flex-col gap-5 lg:w-[60%]">
        <div className="flex flex-col gap-1">
          <h1 className=" font-Inter text-[28px] leading-10 font-bold">
            Your Booked Vehicle is Ready To Go
          </h1>
          <p className=" font-Jakarta text-[16px] leading-[200%]">
            {/* Beautiful Tesla equipped with lots of new technologies for your
            family, friends and navigation on modern screen, apple and android
            play car, aux input, USB input, heated seats, and more!- Our cars do
            not smell like marihuana. */}
          </p>
        </div>
        <button
          type="button"
          onClick={() => {
            navigate(`/vehicles/rental/locate/${rentalId}`);
          }}
          className=" bg-midGreen text-white rounded-md font-Poppins text-[13px] font-semibold py-4 px-6 max-w-fit"
        >
          Locate Vehicle
        </button>
      </div>
      <div className="">
        <img src={carpool} className=" object-cover " alt="" />
      </div>

      {/* <div
        className=" w-[80%] mx-auto  lg:w-[48%] h-[500px] rounded-lg "
        id="mapDiv"
      ></div>
      <div className=" w-[80%] mx-auto lg:w-[48%] bg-white px-6 py-11 flex flex-col gap-7">
        <p className=" font-Inter font-medium leading-6 text-[#3D475C]">
          Active Rentals
        </p>
        <main className="flex gap-2 items-center">
          <section className="flex flex-col gap-3">
            <div className="flex gap-3 items-center">
              <img
                src={ipfsGatewayImage(image)}
                alt=""
                className=" w-[82px] h-[42px] object-cover rounded-md "
              />
              <div className="flex flex-col gap-3">
                <p className=" text-[#1D3A70] font-Roboto font-bold leading-4 text-[12px] ">
                  Booking ID: {activeRental?.id}
                </p>
                <div className=" flex flex-col gap-2">
                  <p className=" text-lightGreyText font-Roboto font-normal leading-4 text-[1opx] ">
                    Plate Number: {activeRental?.carId?.vehiclePlateNumber}
                  </p>
                  <p className=" text-lightGreyText font-Roboto font-normal leading-4 text-[1opx] ">
                    Color: {activeRental?.carId?.color}
                  </p>
                </div>
              </div>
            </div>
            <div className=" bg-[#F4F5F7] rounded-lg p-5 flex flex-col items-center gap-6">
              <div className="flex flex-col items-center">
                <img src={proximity} alt="" />
                <p className=" font-Poppins text-black font-semibold text-[16px] leading-normal">
                  Proximity Unlock
                </p>
              </div>
              <p className=" font-Poppins text-black text-center leading-normal font-normal">
                Get close to the vehicle, and the Unlock button will be enabled
              </p>
              <button className=" font-Poppins rounded-lg p-4 text-white text-center font-normal text-[12px] leading-normal bg-midGreen/70 ">
                Unlock Vehicle
              </button>
            </div>
          </section>
          <section className=" flex flex-col gap-6 ">
            <div className="flex flex-col gap-3">
              <p className=" flex flex-col gap-2 font-Jakarta text-[10px] font-normal leading-4 text-[#90a3bf] ">
                Return Location
                <span className=" tet-[13px] font-semibold leading-5">
                  {vehicleLocation as string}
                </span>
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h1 className=" font-Jakarta font-semibold text-[9px]  uppercase leading-4">
                FEATURES
              </h1>
              <div className="flex flex-col gap-4 ">
                <div className=" flex gap-7">
                  <p className=" flex flex-col gap-2 font-Jakarta text-[10px] font-normal leading-4 text-[#90a3bf] ">
                    Model
                    <span className=" tet-[13px] font-semibold leading-5">
                      {activeRental?.carId.make} {activeRental?.carId.model}
                    </span>
                  </p>
                  <p className=" flex flex-col gap-2 font-Jakarta text-[10px] font-normal leading-4 text-[#90a3bf] ">
                    Color
                    <span className=" tet-[13px] font-semibold leading-5">
                      {activeRental.carId.color}
                    </span>
                  </p>
                  <p className=" flex flex-col gap-2 font-Jakarta text-[10px] font-normal leading-4 text-[#90a3bf] ">
                    Capacity
                    <span className=" tet-[13px] font-semibold leading-5">
                      {activeRental.carId.capacity} people
                    </span>
                  </p>
                </div>
                <div className=" flex gap-7">
                  <p className=" flex flex-col gap-2 font-Jakarta text-[10px] font-normal leading-4 text-[#90a3bf] ">
                    Plate Number
                    <span className=" tet-[13px] font-semibold leading-5">
                      {activeRental.carId.vehiclePlateNumber}
                    </span>
                  </p>
                  <p className=" flex flex-col gap-2 font-Jakarta text-[10px] font-normal leading-4 text-[#90a3bf] ">
                    Mileage per charge
                    <span className=" tet-[13px] font-semibold leading-5">
                      {activeRental.carId.millagePerCharge}km
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div> */}
    </div>
  );
};

export default ActiveRental;
